import Navbar from "../../../Components/Common/navbar";
import InquiryListSection from "./InquiryListSection";
import NavBottomBar from "../../../Components/Common/NavBottomBar";
import MobileViewContainer from "../../../Components/MobileViewContainer";
import { useUserStore } from "../../../store/store";

import kakaoChannelLogo from "../../../assets/social/Kakao_Channel.png";

const InquiryList = () => {
  const siteinfo = useUserStore((state) => state.site);
  console.log("siteinfo", siteinfo);

  return (
    <MobileViewContainer>
      <Navbar activeBar={5} />
      {siteinfo?.kakaoChannelsId && <div
        style={{
          height: "80vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width: "100%",
        }}>
        <div
          style={{
            fontSize: "16px", padding: "15px 15px", cursor: "pointer",
            border: "1px solid #888", borderRadius: "30px",
            boxShadow: "none", display: "flex", alignItems: "center", justifyContent: "center"
          }}
          onClick={() => {
            window.open(`https://pf.kakao.com/${siteinfo?.kakaoChannelsId}`, "_blank")
          }}
          className="flex justify-between items-center">
          <img
            src={kakaoChannelLogo}
            alt="Kakao Channel"
            style={{ height: "32px", marginRight: "10px" }}
          />
          <span style={{
            fontSize: "18px",

          }}>문의하기</span>
        </div>
        <div
          style={{
            fontSize: "14px",
            color: "#999",
            textAlign: "center",
            marginTop: "10px",
            padding: "0 20px",
          }}>
          카카오톡 채널로 문의하기 버튼을 클릭하시면
          <br />
          카카오톡으로 문의하기가 가능합니다.
        </div>
      </div>}
      <InquiryListSection />
      <NavBottomBar activeBar={5} />
    </MobileViewContainer>
  );
};

export default InquiryList;
